import { INSIGHT_STATUS_PUBLISHED } from '../../constants/constants';

export const getPublicInsightsParams = isAdmin => {
    return {
        status: INSIGHT_STATUS_PUBLISHED,
        version: isAdmin,
        type: '',
        page: 1,
        limit: 12,
        order: [{ order: 'date', orderDirection: 'DESC' }]
    };
};
